import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type SnackbarState = {
  delay?: number
  isOpen: boolean
  message?: string
  severity?: "success" | "error" | "info" | "warning"
}

const initialState: SnackbarState = {
  delay: 3000,
  isOpen: false,
  message: "",
  severity: "success",
}

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setOpenSnackbar: (state, action: PayloadAction<SnackbarState>) => {
      state.isOpen = action.payload.isOpen
      state.message = action.payload.message
      state.severity = action.payload.severity
      state.delay = action.payload.delay || state.delay
    },
  },
})

export const { setOpenSnackbar } = snackbarSlice.actions
export default snackbarSlice.reducer
